import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import SubPageView from './SubPageView.js';
import { generate } from '../../router.js';
import { Routes } from '../../routes.js';

@customElement('not-found-view')
class NotFoundView extends SubPageView {
  static styles = [...SubPageView.styles];

  renderContent() {
    return html`
      <h2>We couldn't find what you're looking for...</h2>
      <p>
        Doesn't look like anything is here. Please use the navigation above or
        <a href=${generate(Routes.CONTACT)}>contact us</a> if you're having difficulties.
      </p>
    `;
  }
}
